export const COLUMN_BANNER = [
  {
    label: 'Order',
    stateValue: 'order',
  },
  {
    label: 'URL',
    stateValue: 'name',
  },
  {
    label: 'Preview',
    stateValue: 'preview',
  },
  {
    label: 'Status',
    stateValue: 'status',
  },
  {
    label: 'Start Date',
    stateValue: 'startDate',
  },
  {
    label: 'End Date',
    stateValue: 'endDate',
  },
  {
    label: 'Action',
    stateValue: 'action',
  },
];

export const BANNER_STATUS = {
  Active: 'Active',
  InActive: 'Inactive',
};

export const BANNER_STATUS_COLORS = {
  [BANNER_STATUS.InActive]: {
    txt: '#333333',
    background: '#f1f1f1',
  },
  [BANNER_STATUS.Active]: {
    txt: '#0B8E5E',
    background: '#15a47029',
  },
};

export const TYPE_MODAL = {
  Edit: 'Edit',
  Create: 'Create',
};
